import { render } from "./TemplateAddComponent.vue?vue&type=template&id=7a1931a6&scoped=true"
import script from "./TemplateAddComponent.vue?vue&type=script&lang=js"
export * from "./TemplateAddComponent.vue?vue&type=script&lang=js"

import "./TemplateAddComponent.vue?vue&type=style&index=0&id=7a1931a6&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1931a6"]])

export default __exports__